/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
function customEventPolyfill(document, typeArg, eventInitDict) {
    var params = eventInitDict || { bubbles: false, cancelable: false, detail: null };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(typeArg, params.bubbles || false, params.cancelable || false, params.detail);
    return evt;
}
export function createCustomEvent(document, typeArg, eventInitDict) {
    var win = document === null || document === void 0 ? void 0 : document.defaultView;
    if (!win)
        throw new Error('Document does not have a default view.');
    if (typeof win.CustomEvent !== 'function') {
        return new customEventPolyfill(document, typeArg, eventInitDict);
    }
    return new win.CustomEvent(typeArg, eventInitDict);
}
//# sourceMappingURL=createCustomEvent.js.map